<template>
    <v-app>
        <v-container class="services" v-if="!hasResult">
            <v-layout xs8 md12 row wrap class="title-block">
                <services-breadcrumbs v-if="b2b"></services-breadcrumbs>
                <v-flex>
                    <h1>{{pageTitle}}</h1>
                </v-flex>
            </v-layout>
            <services-carousel
                v-if="!b2b"
                :slides="carouselSlides"
            />
            <services-request-form
                :title="'Введите данные гос. номера или VIN и мы покажем вам информацию о действующем полисе ОСАГО'"
                :loading="loading"
                @find="find"
            />
        </v-container>
        <v-container class="services services-result" v-if="hasResult">
            <v-layout xs8 md12 row wrap class="title-block">
                <services-breadcrumbs v-if="b2b"></services-breadcrumbs>
                <v-flex>
                    <h2>Ваш полис ОСАГО</h2>
                </v-flex>
            </v-layout>
            <v-layout class="main-carousel-slider">
                <v-layout class="main-carousel-slider-block">
                    <v-flex d-flex class="main-carousel-slider-item-content">
                        <div class="main-carousel-slider-icons">
                            <img src="/svg/grimacing-face_3.svg"/>
                            <img src="/svg/alarm-clock.svg"/>
                        </div>
                        <div class="main-carousel-slider-text"
                            v-html="getResultText()"
                        ></div>
                    </v-flex>
                </v-layout>
            </v-layout>
            <v-layout
                class="service-form service-result-list"
                style="max-width: 1240px"
                v-if="!showMore"
            >
                <v-flex class="service-result-list-item">
                    <div>Серия, Номер полиса</div>
                    <div v-html="requestResult.fullPolicyNumber"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Марка, Модель</div>
                    <div v-html="requestResult.markModel"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Дата окончания действия</div>
                    <div v-html="requestResult.endDate"></div>
                </v-flex>
            </v-layout>
            <v-layout
                class="service-form service-result-list"
                style="max-width: 1240px"
                v-if="showMore"
            >
                <v-flex class="service-result-list-item">
                    <div>Номер полиса</div>
                    <div v-html="requestResult.policyNumber"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Серия</div>
                    <div v-html="requestResult.policySeries"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Страховая компания</div>
                    <div v-html="requestResult.insureCompany"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>VIN</div>
                    <div v-html="requestResult.vin"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Регистрационный номер</div>
                    <div v-html="requestResult.gosNumber"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Марка, Модель</div>
                    <div v-html="requestResult.markModel"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Дата начала действия</div>
                    <div v-html="requestResult.startDate"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Дата окончания действия</div>
                    <div v-html="requestResult.endDate"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Статус договора ОСАГО</div>
                    <div v-html="requestResult.policyState"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Статус полиса</div>
                    <div v-html="requestResult.status"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Допущено к управлению</div>
                    <div v-html="requestResult.drivers"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Страхователь</div>
                    <div v-html="requestResult.policyholder"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Собственник</div>
                    <div v-html="requestResult.owner"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>КБМ по договору ОСАГО</div>
                    <div v-html="requestResult.kbm"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>ТС используется в регионе</div>
                    <div v-html="requestResult.region"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Страховая премия</div>
                    <div v-html="requestResult.sum"></div>
                </v-flex>
            </v-layout>
            <v-layout
                class="service-form-button"
                style="max-width: 1240px"
            >
                <v-btn
                    class="button black-button block"
                    @click="showMore = true"
                    v-if="!showMore"
                >
                    Подробнее
                </v-btn>
                <v-btn
                    class="button black-button block"
                    @click="showMore = false"
                    v-if="showMore"
                >
                    Свернуть
                </v-btn>
            </v-layout>
            <services-notification-form
                :title="'Напомнить об окончании срока действия полиса'"
                :requestResult="requestResult"
                :requestUrl="'/services/notification/create'"
                :type="'policy'"
            />
            <v-layout
                pb-4
                class="service-form-button"
                style="max-width: 1240px"
            >
                <v-btn
                    class="button next-button block"
                    @click="resetResult"
                >
                    Назад
                </v-btn>
            </v-layout>
        </v-container>
        <services-underlist v-if="!b2b" />
        <services-list v-if="!b2b" />
    </v-app>
</template>
<script>
    import _ from 'lodash';
    import ServicesBreadcrumbs from "./services/ServicesBreadcrumbs";

    export default {
        components: {'services-breadcrumbs': ServicesBreadcrumbs},
        props: {
            title: {
                default: ''
            },
            b2b: {
                default: false
            }
        },
        data: () => ({
            loading: false,
            hasResult: false,
            requestResult: {
                nameFatherName: null,
                fullPolicyNumber: null,
                markModel: null,
                endDate: null,
                startDate: null,
                policyNumber: null,
                policySeries: null,
                insureCompany: null,
                vin: null,
                gosNumber: null,
            },
            requestResultDefault: {},
            showMore: false,
            pageTitle: 'Проверка полиса ОСАГО по базе РСА',
            carouselSlides: [
                'Найдите информацию о действующем полисе ОСАГО по гос. номеру или VIN автомобиля. Напомним заранее об окончании срока действия.',
                'Вы больше не забудете продлить страховку и не получите штраф отсутствие полиса.',
                'Проверьте полис на подлинность, есть ли он в базе РСА.'
            ]
        }),
        created() {
            this.requestResultDefault = _.cloneDeep(this.requestResult)
            if(this.title) {
                this.pageTitle = this.title
            }
        },
        methods: {

            find(data) {
                this.loading = true
                try {
                    grecaptcha.ready(() => {
                        grecaptcha.execute(
                            Vue.GetpolisConstants.RECAPTCHA_SITEKEY,
                            {action: Vue.GetpolisConstants.RECAPTCHA_ACTIONS.POLICY}
                        ).then(token => {
                            data.r = token
                            axios.post('/services/getpolicy', data)
                            .then(response => {
                                this.hasResult = true
                                this.requestResult = response.data
                                window.scrollTo(0,0);
                            })
                            .catch(error => {
                                console.log(error)
                                PNotify.error(error.response.data.message)
                            })
                            .finally(() => {
                                this.$nextTick(() => {
                                    this.loading = false
                                })
                            })
                        });
                    })
                } catch (e) {
                    console.log(e);
                }
            },

            getResultText() {
                return `${this.requestResult.nameFatherName}, ваш полис ОСАГО на автомобиль ${this.requestResult.markModel} в страховой компании ${this.requestResult.insureCompany} действует <b>до ${this.requestResult.endDate}</b>. Установите напоминание и продлите ОСАГО без перерыва срока действия.`
            },

            resetResult() {
                this.requestResult = _.cloneDeep(this.requestResultDefault)
                this.showMore = false
                this.hasResult = false
                window.scrollTo(0,0)
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/ServicesPage.vue